/**
 * config.js
 */
(function(){

	/**
	 * Set config.
	 */
	window.px2style.setConfig = function(){
		console.error('px2style.setConfig() was obsoleted.');
		return true;
	}

	/**
	 * Get config.
	 */
	window.px2style.getConfig = function(key){
		console.error('px2style.getConfig() was obsoleted.');
		return false;
	}

})();
